/** package.json の version を scripts/write-commo-build-version.mjs が同期。手で直さない。 */
export const COMMO_BUILD_VERSION = "0.15.3" as const;
